import React, { useEffect, useState } from 'react';

import "../../../css/components/OrderInfo/EditOrderModal/EditOrderModal.css";

import { Message } from '../../../utils/Message';
import { delay, formatTaiwanDateTime } from '../../../utils';
import { useUser } from '../../../hooks/useUser';
import { EditStaffOrderModalList } from '../../../constants/StaffOrderModal/StaffOrderModal';
import { TruckLoanApplicationForm } from '../../TruckLoanApplication';

import { updateDeliverOrder } from '../../../service/api/StaffOrder/apiStaffOrder';
import { getDeliver } from '../../../service/api/Deliver/apiDeliver';

const EditStaffOrderModal = ({ order, onClose, setRecordsData, mode: propMode = 'personal', deliversData }) => {
  // 如果 order.mode 有值就使用它，否則使用傳入的 mode
  // propMode 在司機頁面會傳入 'deliver'，在管理員頁面會有 'personal' 或 'company'
  const mode = order?.mode || propMode;

  const [showLoanForm, setShowLoanForm] = useState(false);
  const [vehicleInfo, setVehicleInfo] = useState(null);
  const [loanFormData, setLoanFormData] = useState(null); // 保存借車申請表單的數據
  const [pendingForm, setPendingForm] = useState(null);
  const originForm = {
    id: order?.id,
    company: order?.company,
    name: order?.name,
    phone: order?.phone,
    plate: order?.plate,
    isReturned: order?.isReturned,
    furnitureCount: order?.furnitureCount,
    status: order?.status,
    usedAt: order?.usedAt,
    finishAt: order?.finishAt,
    returnAt: order?.returnAt,
  };
  const [form, setForm] = useState({
    id: order?.id,
    company: order?.company,
    employeeId: null,
    name: order?.name,
    phone: order?.phone,
    plate: order?.plate,
    isReturned: order?.isReturned,
    category: order?.category,
    furnitureCount: order?.furnitureCount,
    status: order?.status,
    usedAt: order?.usedAt,
    finishAt: order?.finishAt,
    returnAt: order?.returnAt,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (propMode === 'deliver' && name === 'name') return;

    console.log(name, value);
    if (name === 'name') {
      const selectedDeliver = deliversData.find(deliver => deliver.name === value);
      setForm(prev => ({
        ...prev,
        employeeId: selectedDeliver?.id || '',
        phone: selectedDeliver?.phone || '',
        company: selectedDeliver?.company || '',
        plate: '', // 清空車牌，讓用戶重新選擇
      }));
    }
    setForm(prev => ({
      ...prev,
      [name]: name === "plate" ? value.toUpperCase() : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(form)

    // 如果是順康公司與有變動form，則先填寫借車申請表單，送出成功後再送出派車單
    if (form.company === '順康資產管理顧問股份有限公司' && (
      form.name !== originForm.name ||
      form.phone !== originForm.phone ||
      form.plate !== originForm.plate ||
      form.usedAt !== originForm.usedAt ||
      form.finishAt !== originForm.finishAt ||
      form.returnAt !== originForm.returnAt)) {
      console.log('需要填寫借車申請表單');
      setPendingForm(form);
      setShowLoanForm(true);
      setVehicleInfo(deliversData.find(deliver => deliver.name === form.name)?.vehicles?.find(vehicle => vehicle.plate === form.plate) || null);
      console.log(order.truckLoanApplication)
      setLoanFormData(order.truckLoanApplication);
      return;
    }

    const response = await updateDeliverOrder(form);
    console.log(response.data);
    if (response.status === 200 && response.data.status === 1) {
      Message(response.data.message);
      await delay(1);
      onClose(null);
      setRecordsData?.(prev => prev.map(o => o.id === form.id ? response.data.result : o))
    } else {
      Message(response.data.message, 'warning');
    }
  };

  // 借車申請送出成功後，等待主管方審核通過後由主管方觸發 onSubmit，將借車申請資訊附加到派車單一起送出
  // 因此不再在這裡直接呼叫 updateDeliverOrder，而是將表單數據暫存起來，等待審核結果
  const handleLoanFormSubmit = async (loanApplication) => {
    setShowLoanForm(false);
    // 保留 loanFormData，如有誤可重新編輯
    // setLoanFormData(null);
    if (pendingForm) {
      // 將借車申請資訊附加到派車單
      const formWithLoan = {
        ...pendingForm,
        loanApplication: loanApplication
      };
      console.log('派車單含借車申請:', formWithLoan);
      const response = await updateDeliverOrder(formWithLoan);
      console.log(response.data);
      if (response.status === 200 && response.data.status === 1) {
        Message(response.data.message);
        await delay(1);
        onClose(null);
        setRecordsData?.(prev => prev.map(o => o.id === form.id ? { ...o, truckLoanApplication: response.data.result } : o))
        setPendingForm(null);
      } else {
        Message(response.data.message, 'warning');
      }
    }
  };

  // 如果顯示借車申請表單
  if (showLoanForm) {
    return (
      <div className="truckLoanApplicationForm custom-modal-backdrop">
        <div className="custom-modal" style={{ width: '1200px', maxHeight: '90vh', overflow: 'auto' }}>
          <TruckLoanApplicationForm
            mode="embedded"
            vehicleInfo={vehicleInfo}
            deliverInfo={{
              id: form.employeeId,
              name: form.name,
              phone: form.phone,
              company: form.company,
            }}
            deliverOrderInfo={{
              usedAt: form.usedAt,
              finishAt: form.finishAt,
              returnAt: form.returnAt,
              category: form.category,
            }}
            initialData={loanFormData}
            onDataChange={setLoanFormData}
            onSubmit={handleLoanFormSubmit}
            onCancel={() => setShowLoanForm(false)}
          />
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="custom-modal-backdrop">
        <div className="custom-modal">
          <div className="custom-modal-header">
            <h5 className="modal-title">編輯派車單 {order?.number}</h5>
            <button className="btn-close" onClick={(e) => { onClose(null); e.preventDefault(); }}></button>
          </div>

          <div className="custom-modal-body">
            {/* 司機 */}
            <div className="input-group mb-3">
              <span className="input-group-text">司機</span>
              <select
                className="form-select"
                name='name'
                value={form.name}
                onChange={handleChange}
                required
                disabled={propMode === 'deliver'}
              >
                <option disabled value="">請選擇司機</option>
                {
                  deliversData
                    .filter(deliver =>
                      (propMode === 'deliver' && form.name === deliver.name) ||
                      (mode === 'personal' && !deliver.company) ||
                      (mode === 'company' && deliver.company)
                    )
                    .map(deliver =>
                      <option key={deliver.id} data-id={deliver.id} value={deliver.name}>
                        {deliver.name}
                      </option>)
                }
              </select>
            </div>

            {/* 車牌 - 根據選擇的司機顯示可用車輛 */}
            <div className="input-group mb-3">
              <span className="input-group-text">
                車牌
                <span className="required-star">*</span>
              </span>
              <select
                className="form-select"
                name='plate'
                value={form.plate}
                onChange={handleChange}
                required
              >
                <option value="">請選擇車牌</option>
                {form.name && deliversData.find(deliver => deliver.name === form.name)?.vehicles?.length > 0 ? (
                  deliversData
                    .find(deliver => deliver.name === form.name)
                    ?.vehicles?.map(vehicle => (
                      <option key={vehicle.id} value={vehicle.plate}>
                        {vehicle.plate} ({vehicle.model})
                      </option>
                    ))
                ) : (
                  form.name && <option disabled>無資料</option>
                )}
              </select>
            </div>
            {/* 基本資訊 */}
            {EditStaffOrderModalList
              .filter(field => (!field.mode || field.mode === mode) && field.name !== 'plate')
              .map(field => (
                <div className="input-group mb-3" key={field.name}>
                  <span className="input-group-text">
                    {field.label}
                    {form.company === '順康資產管理顧問股份有限公司' && field.value === "returnAt" ? <span className="required-star">*</span> : field.required && <span className="required-star">*</span>}
                  </span>
                  <input
                    type={field.type}
                    className="form-control"
                    name={field.value}
                    value={field.type === 'datetime-local' ? formatTaiwanDateTime(form[field.value]) : form[field.value]}
                    onChange={handleChange}
                    placeholder={field.placeholder || ""}
                    required={form.company === '順康資產管理顧問股份有限公司' && field.value === "returnAt" ? true : field.required}
                    pattern={field.pattern}
                    title={field.title}
                    max={field.max}
                    min={field.min}
                    disabled={field.disabled}
                  />
                </div>
              ))}
          </div>

          <div className="custom-modal-footer">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="category"
                name="category"
                checked={form.category === 1}
                onChange={(e) => {
                  setForm(prev => ({
                    ...prev,
                    category: e.target.checked ? 1 : 2
                  }));
                }}
              />
              <label className="form-check-label" htmlFor="category">
                提供送貨服務
              </label>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-secondary" onClick={(e) => { onClose(null); e.preventDefault(); }}>取消</button>
              <button className="btn btn-gradient-primary" type="submit">儲存</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export { EditStaffOrderModal };
